import PhotoBanner from "./PhotoBanner";
export default PhotoBanner;
